import { render } from "./UserAdminEdit.vue?vue&type=template&id=7ca0b615"
import script from "./UserAdminEdit.vue?vue&type=script&lang=js"
export * from "./UserAdminEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__